import { Backdrop, styled } from '@mui/material';

export const StyledBackdrop = styled(Backdrop)({
  position: 'absolute',
});
